import React from "react";
// import { useState } from "react";
import { Link } from "gatsby";
import HeroHomeCollage from "./HeroHomeCollage";
import heroImage from "../images/heros-and-graphics/plot_curves-20_points-5_spread-0.35_line-width-0.5_line-width-variability-0.10_seed-3338416735.png";
function HeroHome() {
  // const [videoModalOpen, setVideoModalOpen] = useState(false);

  return (
    <section className="relative">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="absolute inset-0 bg-opacity-0 z-0 h-[400px] w-full mt-[150px] lg:mt-[25px]">
          <img
            className="w-full min-w-[1000px] opacity-100 overflow-visible"
            src={heroImage}
            alt="Hero"
          />
        </div>

        {/* Hero content */}
        <div className="pt-28 pb-8 z-10">
          {/* Section header */}
          <div className="text-center pb-4">
            <h1
              className="text-[3rem] md:text-[4rem] font-bold leading-tighter tracking-tighter mb-4 pb-4 bg-clip-text text-transparent bg-gradient-to-r from-rhoBlueLight-700 to-rhoBlueLight-600 drop-shadow-lg"
              data-aos="zoom-y-out"
            >
              {/* Projections
              <br />
              for Net Zero */}
              Modeling the
              <br />
              Transition to Net Zero
            </h1>
            <div className="max-w-3xl mx-auto">
              <h2 className="hidden">
                Powering the world's most reliable impact forecasts.
              </h2>
              <p
                className="md:text-[1.9rem] text-[1.25rem] text-rhoBlueDark-700 mb-0 px-2"
                data-aos="zoom-y-out"
                data-aos-delay="150"
                style={{ textAlign: "center", textAlignLast: "center" }}
              >
                Industry leaders are driving their customers and sectors towards
                a decarbonized future.
              </p>
              <div
                className="max-w-xs mx-auto sm:max-w-none sm:flex sm:justify-center"
                data-aos="zoom-y-out"
                data-aos-delay="300"
              >
                <div className="max-w-sm md:max-w-4xl mx-auto grid gap-6 pt-10 md:gap-12 grid-cols-1 md:grid-cols-2">
                  <div>
                    <Link
                      className="btn text-white bg-rhoBlueLight-700 hover:bg-rhoBlueLight-800 w-full group drop-shadow-lg hover:drop-shadow-md transition-shadow duration-300"
                      to="/contact/?topic=Demo"
                    >
                      Request a Demo&nbsp;&nbsp;
                      <span className="inline-block transform transition-transform duration-300 group-hover:translate-x-2">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </Link>
                  </div>

                  <div>
                    <a
                      href="https://koi.eco/"
                      target="_blank"
                      rel="noreferrer"
                      className="btn group text-black bg-rhoBlueLight-100 hover:bg-rhoLime-700 w-full drop-shadow-lg hover:drop-shadow-md transition-shadow duration-300"
                    >
                      Model in Koi&nbsp;&nbsp;
                      <span className="inline-block transform transition-transform duration-300 group-hover:translate-x-2 group-hover:-translate-y-1">
                        <i className="fa-kit fa-koi-icon-flat"></i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Hero image */}
          <HeroHomeCollage />
        </div>
      </div>
    </section>
  );
}

export default HeroHome;
